module.exports = __webpack_public_path__ + "img/gotit.2a6331a6.png";